// Helper function to get value from nested path (supports dot notation like "parent.child.field")
export const getNestedValue = (obj: any, path: string): any => {
  if (!obj || !path) return undefined;
  if (path.includes('.')) {
    const pathParts = path.split('.');
    let current: any = obj;

    for (const part of pathParts) {
      if (current && typeof current === 'object' && part in current) {
        current = current[part];
      } else {
        return undefined;
      }
    }
    return current;
  }
  return obj[path];
};
